import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useAxios from "../../../../MainComponents/Hooks/useAxios.jsx";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { Editor as ClassicEditor } from "ckeditor5-custom-build/build/ckeditor";
import { toast } from "react-hot-toast";
import HelmetTags from "../../../../MainComponents/HelmetTags.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import { useForm, useFieldArray } from "react-hook-form";

function AddEditChooseQuestion({
  edit,
  type,
  id,
  lectureQuestion,
  refetch,
  setRefetch,
}) {
  const { categoryID, questionID, examID } = useParams();

  let QuestionDataApi = lectureQuestion
    ? `${process.env.REACT_APP_QUIZ_HOMEWORK_QUESTION_INFO_API}${questionID}`
    : `${process.env.REACT_APP_QUESTION_INFO_API}${questionID}`;
  const [QuestionDataSuccess, QuestionErrors, loading] = useAxios(
    QuestionDataApi,
    "GET",
    edit
  );

  const [question, setQuestion] = useState("");
  const [difficulty, setDifficulty] = useState("");
  const [degree, setDegree] = useState("");

  const {
    control,
    register,
    handleSubmit: handleFormSubmit,
    setValue,
    watch,
    formState: { errors: formErrors },
  } = useForm({
    defaultValues: {
      answers: [
        { text: "", is_correct: false },
        { text: "", is_correct: false },
        { text: "", is_correct: false },
        { text: "", is_correct: false },
      ],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "answers",
  });

  const answers = watch("answers");

  useEffect(() => {
    if (question !== "") {
      setErrors("");
    } else if (difficulty !== "") {
      setErrors("");
    } else if (degree !== "") {
      setErrors("");
    }
  }, [question, difficulty, degree]);

  const [errors, setErrors] = useState("");
  const navigate = useNavigate();

  const [submitQuestion, setSubmitQuestion] = useState({
    flag: "",
    dependency: false,
    data: {},
  });

  let api =
    type === "homework"
      ? process.env.REACT_APP_ADMIN_ADD_HOMEWORK_CHOOSE_QUESTIONS_API
      : type === "quiz"
      ? process.env.REACT_APP_ADMIN_ADD_QUIZ_CHOOSE_QUESTIONS_API
      : type === "exam"
      ? process.env.REACT_APP_ADMIN_TRIAL_EXAM_ADD_CHOOSE_QUESTION_API
      : edit
      ? process.env.REACT_APP_EDIT_QUESTION_API
      : `${process.env.REACT_APP_ADD_CHOOSE_QUESTION_API}${categoryID}`;
  const [addEditQuestionSuccess, addEditQuestionErrors, submitLoading] =
    useAxios(
      api,
      "POST",
      submitQuestion.flag,
      submitQuestion.dependency,
      submitQuestion.data,
      true
    );

  useEffect(() => {
    if (QuestionDataSuccess) {
      setQuestion(QuestionDataSuccess.data.question);
      setDifficulty(QuestionDataSuccess.data.difficulty);
      setDegree(QuestionDataSuccess.data?.degree);

      if (
        QuestionDataSuccess.data.answers &&
        Array.isArray(QuestionDataSuccess.data.answers)
      ) {
        setValue("answers", QuestionDataSuccess.data.answers);
      }
    }
  }, [QuestionDataSuccess, setValue]);

  const onSubmit = (formData) => {
    if (question === "") {
      setErrors("question");
      toast.error("برجاء ملئ جميع البيانات المطلوبة");
      return;
    }

    if (formData.answers.length < 2) {
      toast.error("يجب إضافة إجابتين على الأقل");
      return;
    }

    const emptyAnswer = formData.answers.find(
      (a) => !a.text || a.text.trim() === ""
    );
    if (emptyAnswer) {
      toast.error("برجاء ملئ جميع الإجابات");
      return;
    }

    const hasCorrect = formData.answers.some((a) => a.is_correct);
    if (!hasCorrect) {
      toast.error("برجاء اختيار إجابة صحيحة واحدة على الأقل");
      return;
    }

    if (difficulty === "" && !type) {
      setErrors("difficulty");
      toast.error("برجاء ملئ جميع البيانات المطلوبة");
      return;
    }

    if (degree === "" || Number(degree) < 1) {
      setErrors("degree");
      toast.error("من فضلك ادخل رقم اكبر من صفر");
      return;
    }

    let data = {
      question: question,
      answers: formData.answers.map((a) => {
        return { ...a, is_correct: a.is_correct ? 1 : 0 };
      }),
      difficulty: difficulty,
      degree: degree,
    };

    if (type === "homework") {
      data.homework_id = id;
    } else if (type === "quiz") {
      data.quiz_id = id;
    } else if (type === "exam") {
      data.exam_id = id;
    } else {
      data.id = edit ? questionID : categoryID;
    }

    setSubmitQuestion({
      flag: "addEditQuestionRequest",
      dependency: !submitQuestion.dependency,
      data: data,
    });
  };

  useEffect(() => {
    if (addEditQuestionSuccess) {
      setQuestion("");
      setDifficulty("");
      setDegree("");
      setErrors("");
      setValue("answers", [
        { text: "", is_correct: false },
        { text: "", is_correct: false },
        { text: "", is_correct: false },
        { text: "", is_correct: false },
      ]);
      edit && navigate(-1);
      type && setRefetch(!refetch);
    }
  }, [addEditQuestionSuccess]);

  const handleBubbleSheet = (checked) => {
    if (checked) {
      setValue("answers", [
        { text: "<h2></h2> <h2>A</h2>", is_correct: false },
        { text: "<h2></h2> <h2>B</h2>", is_correct: false },
        { text: "<h2></h2> <h2>C</h2>", is_correct: false },
        { text: "<h2></h2> <h2>D</h2>", is_correct: false },
      ]);
    } else {
      setValue(
        "answers",
        fields.map(() => ({ text: "", is_correct: false }))
      );
    }
  };

  return (
    <section className="flex h-auto w-full flex-col items-center dark:bg-dark dark:text-light">
      {!type && (
        <HelmetTags title="بنك الاسئلة | مسيو بلال عبدالله "></HelmetTags>
      )}
      <form
        method="post"
        onSubmit={handleFormSubmit(onSubmit)}
        className="form-container my-20 flex flex-col items-center bg-secondary text-white p-8 rounded-3xl "
      >
        <h2 className="my-20 text-center text-3xl font-bold">
          {edit
            ? "من فضلك قم بملئ البيانات لتعديل السؤال "
            : "من فضلك قم بملئ البيانات لإضافة السؤال"}{" "}
        </h2>
        {/**
         * //!------question-----
         */}
        <div className=" question mb-10 flex w-[900px] flex-col items-end gap-2 xsl:w-[700px] amd:w-[500px] sm:w-[300px]">
          <div className="mb-3 w-full flex justify-between items-center gap-5 md:flex-col md:items-center">
            <div className=" bubble flex w-1/2 flex-col items-start justify-center gap-2 md:w-full ">
              <div className="flex w-full items-center justify-start gap-10">
                <label className="visibility-switch">
                  <input
                    className=""
                    id="bubble"
                    name="bubble"
                    type="checkbox"
                    onChange={(e) => handleBubbleSheet(e.target.checked)}
                  />
                  <span className="visibility-slider">
                    <svg
                      className="slider-icon"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <path fill="none" d="m4 16.5 8 8 16-16"></path>
                    </svg>
                  </span>
                </label>
                <div>
                  <label
                    className="w-full cursor-pointer truncate"
                    htmlFor="bubble"
                  >
                    Bubble Sheet
                  </label>
                </div>
              </div>
            </div>
            <h2 className="mb-3 text-3xl font-semibold">السؤال</h2>
          </div>
          <div className="text-black">
            <CKEditor
              config={{
                toolbar: {
                  items: [
                    "undo",
                    "redo",
                    "|",
                    "imageInsert",
                    "|",
                    "heading",
                    "bold",
                    "italic",
                    "strikethrough",
                    "underline",
                    "link",
                    "blockQuote",
                    "removeFormat",
                    "|",
                    "selectAll",
                    "specialCharacters",
                    "superscript",
                    "subscript",
                    "style",
                    "|",
                    "bulletedList",
                    "numberedList",
                    "outdent",
                    "indent",
                    "|",
                    "mediaEmbed",
                    "insertTable",
                    "|",
                    "fontFamily",
                    "fontColor",
                    "fontBackgroundColor",
                    "fontSize",
                    "highlight",
                    "|",
                    "horizontalLine",
                    "pageBreak",
                    "findAndReplace",
                    "restrictedEditingException",
                    "textPartLanguage",
                    "-",
                  ],
                  shouldNotGroupWhenFull: true,
                },
                language: "en",
                image: {
                  toolbar: [
                    "imageTextAlternative",
                    "toggleImageCaption",
                    "imageStyle:inline",
                    "imageStyle:block",
                    "imageStyle:side",
                  ],
                },
                table: {
                  contentToolbar: [
                    "tableColumn",
                    "tableRow",
                    "mergeTableCells",
                    "tableCellProperties",
                    "tableProperties",
                  ],
                },
              }}
              editor={ClassicEditor}
              data={question}
              onChange={(event, editor) => {
                const data = editor.getData();
                setQuestion(data);
              }}
            />
            {errors === "question" && (
              <p className="text-[12px] text-white ">برجاء ملئ هذا الحقل</p>
            )}
            {addEditQuestionErrors &&
              addEditQuestionErrors?.response?.data?.errors?.question && (
                <p className="w-full text-end text-[12px] text-white  ">
                  {addEditQuestionErrors?.response?.data?.errors?.question[0]}
                </p>
              )}
          </div>
        </div>

        {/**
         * //!------Dynamic Answers-----
         */}
        {fields.map((field, index) => (
          <div
            key={field.id}
            className="answer1 my-10 flex w-[900px] flex-col items-end gap-2 xsl:w-[700px] amd:w-[500px] sm:w-[300px]"
          >
            <div className="w-full flex justify-between items-center mb-3">
              <div className="flex gap-4 items-center">
                {fields.length > 2 && (
                  <button
                    type="button"
                    onClick={() => remove(index)}
                    className="text-red-500 hover:text-red-700"
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </button>
                )}

                <div className=" visibility flex flex-col items-end justify-center gap-2 md:w-full">
                  <div className="flex w-full items-center justify-end gap-10">
                    <label className="visibility-switch">
                      <input
                        type="checkbox"
                        {...register(`answers.${index}.is_correct`)}
                        className="w-5 h-5"
                      />

                      <span className="visibility-slider">
                        <svg
                          className="slider-icon"
                          viewBox="0 0 32 32"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          role="presentation"
                        >
                          <path fill="none" d="m4 16.5 8 8 16-16"></path>
                        </svg>
                      </span>
                    </label>
                    <div>
                      <label
                        className="w-full cursor-pointer truncate"
                        htmlFor="visibility"
                      >
                        إجابة صحيحة
                      </label>
                    </div>
                  </div>
                </div>
                <label className="flex items-center gap-2 cursor-pointer">
                  <span></span>
                </label>
              </div>
              <h2 className="text-3xl font-semibold">الإجابة {index + 1}</h2>
            </div>
            <div className="text-black w-full">
              <CKEditor
                config={{
                  toolbar: {
                    items: [
                      "undo",
                      "redo",
                      "|",
                      "imageInsert",
                      "|",
                      "heading",
                      "bold",
                      "italic",
                      "strikethrough",
                      "underline",
                      "link",
                      "blockQuote",
                      "removeFormat",
                      "|",
                      "selectAll",
                      "specialCharacters",
                      "superscript",
                      "subscript",
                      "style",
                      "|",
                      "bulletedList",
                      "numberedList",
                      "outdent",
                      "indent",
                      "|",
                      "mediaEmbed",
                      "insertTable",
                      "|",
                      "fontFamily",
                      "fontColor",
                      "fontBackgroundColor",
                      "fontSize",
                      "highlight",
                      "|",
                      "horizontalLine",
                      "pageBreak",
                      "findAndReplace",
                      "restrictedEditingException",
                      "textPartLanguage",
                      "-",
                    ],
                    shouldNotGroupWhenFull: true,
                  },
                  language: "en",
                  image: {
                    toolbar: [
                      "imageTextAlternative",
                      "toggleImageCaption",
                      "imageStyle:inline",
                      "imageStyle:block",
                      "imageStyle:side",
                    ],
                  },
                  table: {
                    contentToolbar: [
                      "tableColumn",
                      "tableRow",
                      "mergeTableCells",
                      "tableCellProperties",
                      "tableProperties",
                    ],
                  },
                }}
                editor={ClassicEditor}
                data={answers[index]?.text || ""}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setValue(`answers.${index}.text`, data);
                }}
              />
            </div>
          </div>
        ))}

        <button
          type="button"
          onClick={() => append({ text: "", is_correct: false })}
          className="mb-10 flex items-center gap-2 bg-accent active:scale-95 text-white px-6 py-3 rounded-lg"
        >
          <FontAwesomeIcon icon={faPlus} />
          <span>إضافة إجابة جديدة</span>
        </button>

        {/**
         * //!---------difficulty & degree
         */}
        <div className="flex w-full items-start justify-between gap-10 md:flex-col-reverse my-10">
          {!type && !lectureQuestion && (
            <div
              className={` flex w-1/2 flex-col items-end justify-center gap-2  md:w-full `}
            >
              <label className="w-full truncate" htmlFor="difficulty">
                المستوي{" "}
              </label>
              <select
                value={difficulty}
                onChange={(e) => setDifficulty(e.target.value)}
                className="w-80"
                name="difficulty"
                id="difficulty"
              >
                <option hidden value=""></option>
                <option value="easy">سهل</option>
                <option value="medium">متوسط</option>
                <option value="hard">صعب</option>
              </select>

              {errors === "difficulty" && (
                <p className="text-[12px] text-white ">برجاء ملئ هذا الحقل</p>
              )}
              {addEditQuestionErrors &&
                addEditQuestionErrors?.response?.data?.errors?.difficulty && (
                  <p className="w-full text-end text-[12px] text-white  ">
                    {
                      addEditQuestionErrors?.response?.data?.errors
                        ?.difficulty[0]
                    }
                  </p>
                )}
            </div>
          )}
          <div className=" Degree flex   flex-col items-end justify-center gap-2 w-full">
            <label className="w-full truncate" htmlFor="degree">
              الدرجة
            </label>
            <input
              className="signin-inputs w-full "
              type="number"
              inputMode="numeric"
              min={1}
              value={degree}
              onChange={(e) => setDegree(e.target.value)}
              id="degree"
              placeholder="000"
              name="degree"
              autoComplete="on"
            />

            {errors === "degree" && (
              <p className="text-[12px] text-white ">برجاء ملئ هذا الحقل</p>
            )}
            {addEditQuestionErrors &&
              addEditQuestionErrors?.response?.data?.errors?.degree && (
                <p className="text-[12px] text-white ">
                  {addEditQuestionErrors?.response?.data?.errors?.degree[0]}
                </p>
              )}
          </div>
        </div>

        <button
          disabled={submitLoading && submitQuestion.flag}
          className=" submit mt-6 w-full "
          type="submit"
        >
          {submitLoading && submitQuestion.flag ? (
            <FontAwesomeIcon icon={faSpinner} spin />
          ) : (
            <p> {edit ? "تعديل السؤال" : "اضافة السؤال"}</p>
          )}
        </button>
      </form>
    </section>
  );
}

export default AddEditChooseQuestion;
